<template>
	<div class="card-v2 card-avi">
		
		<div :class="{'pl-16 lg-pl-4': showProfileCompletion}" class="card-avi-profile pb-24 border-bottom-07 flex-top">
			<div class="left flex-top grow">
				<div :class="{ 'mr-28': showProfileCompletion }" class="avatar-wrap mr-24 no-shrink">
					<div v-if="showProfileCompletion" class="profile-completion">
						<div class="inner"></div>
						<svg class="completion-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
							<path
								id="base-timer-path-remaining"
								:stroke-dasharray="profileCompletionStroke"
								fill="transparent"
								stroke="red"
								str
								class="completion-white"
								d="
								M 50, 50
								m -45, 0
								a 45,45 0 1,0 90,0
								a 45,45 0 1,0 -90,0
								"
							></path>
						</svg>
						<div class="profile-completion-badge" :style="completionBadgeTransform">{{ profileCompletion }}%</div>
					</div>
					<ProfileAvatar :profile="$activeProfile" size="80" class="square-80" />
				</div>
				<div>
					<router-link :to="{ name: $routes.Profile.name }" class="fw-700 fs-18 lh-22 color-violet mb-4">{{ $activeUser.name }}</router-link>
					<Rating class="mb-12" :value="$activeProfile" />
					<div v-if="showProfileCompletion" class="profile-links flex wrap gap-8 mt-4 fs-12 lh-14 color-gray">
						<span>{{ profileCompletion }}% Complete</span>
						<router-link :to="{ name: $routes.Profile.name, params: { 'edit': true } }">Finish Profile Now</router-link>
					</div>
				</div>
			</div>
			<div class="util-buttons pl-12 flex-right gap-8">
				<ShareProfileButton
					class="btn-util square-32 tooltip-container"
					@mouseenter="showShareProfileTooltip = true"
					@mouseleave="showShareProfileTooltip = false"
				>
					<icon-share-new />
					<Tooltip v-model="showShareProfileTooltip" arrow="bottom right">
						<p>Share Your Profile and Availability</p>
					</Tooltip>
				</ShareProfileButton>
			</div>
		</div>

		<div class="flex-col sm-2s lg-2s gap-16 mt-24 mx-auto" style="max-width:500px;">
			<router-link :to="{ name: $routes.FindHelpDetails.name }" class="btn btn-large btn-green"><icon-plus-alt class="mr-8"/>Hire Help</router-link>
			<router-link :to="{ name: $routes.Profile.name, params: { 'edit': true } }" class="btn btn-large">Edit Profile</router-link>
		</div>
	</div>
</template>

<script>
import { request } from '@/plugins/axios';

export default {
	name: 'CardAvi',
	components: {},
	data() {
		return {
			showModal: true,
			loading: true,
			showEditProfileTooltip: false,
			showReferTooltip: false,
			showShareProfileTooltip: false,
			showA10yDatesModal: false,
			showA10ySettingsModal: false,
		};
	},
	computed: {
		completionBadgeTransform() {
			let d = (this.profileCompletion / 100) * 360 - 90;
			if ( d < 0 ) {
				d = 350 + d;
			}
			// 46px = radius of .profile-completion
			return `transform: rotate(${d}deg) translate(46px) rotate(-${d}deg)`;
		},
		profileCompletion() {
			return this.$activeProfile?.profileCompletion || 0;
		},
		profileCompletionStroke() {
			const diff = 100 - this.profileCompletion;
			const first = ((diff / 100) * 283).toFixed(0);
			return `${first} 283`;
		},
		showProfileCompletion() {
			const { profileCompletion } = this;
			return !!profileCompletion && profileCompletion < 100;
		},
	},
	methods: {
		async fetchData() {
			try {
				await this.$store.dispatch('users/getActiveUser');
				const profile = this.$activeProfile;
				if (profile && !profile.profileCompletion) {
					/** @type {import('axios').AxiosResponse<Partial<ProfileData>>} */
					const response = await request({
						url: '/profiles/me/',
						method: 'get',
					});
					profile.profileCompletion = response.data.profileCompletion;
				}
			} finally {
				this.loading = false;
			}
		}
	},
	mounted() {
		this.fetchData();
	},
}
</script>
